<mat-card class="error-card">
  <mat-card-content class="error-content">
    <mat-icon class="error-icon" color="warn">error_outline</mat-icon>
    <h3 class="error-message">Error during loading</h3>
    <p class="error-details">Please refresh the site or contact a moderator</p>
  </mat-card-content>
</mat-card>
